import { render } from "./HelpGuidePage.vue?vue&type=template&id=66810af0&ts=true"
import script from "./HelpGuidePage.vue?vue&type=script&lang=ts"
export * from "./HelpGuidePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__